import { Box } from '@chakra-ui/react';

import { MainSearch } from '../../filters/main-search/main-search';
import MobileFilterModal from '../../filters/new-filters/mobile-filter-modal/mobile-filter-modal';
import { DefaultFilters } from '../../filters/new-filters/new-filters';
import NewFiltersServer from '../../filters/new-filters/new-filters-server';
import { SearchFiltersWrapper } from '../search-filters-wrapper/search-filters-wrapper';
import {
  getFilterCounts,
  ParamsSchema,
  searchParamsCache,
} from '../search-results/search-params';

import styles from './new-search.module.scss';

export function NewSearchFilters({ ...defaultFilters }: DefaultFilters) {
  const params = ParamsSchema.parse(searchParamsCache.all());

  const filterCounts = getFilterCounts(params);

  const totalFilterCount = Object.values(filterCounts).reduce(
    (acc, value) => acc + value,
    0,
  );

  return (
    <SearchFiltersWrapper>
      <Box className={styles.searchWrapper}>
        <MainSearch />
        <MobileFilterModal count={totalFilterCount}>
          <NewFiltersServer {...defaultFilters} />
        </MobileFilterModal>
      </Box>
      <Box
        className={styles.filtersDesktop}
        display={{ lg: 'block', base: 'none' }}
      >
        <NewFiltersServer {...defaultFilters} />
      </Box>
    </SearchFiltersWrapper>
  );
}
